// Real enums file. When we convrt enums.js to real enums we could change the file name.
export function enumToList<T>(enumType: T): { display: string; value: number }[] {
	return Object.keys(enumType)
		.filter(key => isNaN(Number(key))) // Filter out the numeric keys
		.map(key => ({
			display: key,
			value: (enumType as any)[key], // Use 'any' to bypass type checking
		}));
}

export enum EmployeePermissionsType {
	// MAIN MENU SECTIONS
	AccessCustomersPage = 10,
	AccessDealsPage = 20,
	AccessCancelCoveragePage = 30,
	AccessServiceLookupPage = 40,
	AccessReportsPage = 50,
	AccessSettingsPage = 60,
	AccessUtilitiesPage = 70,
	AccessAccountingPage = 80,
	AccessSandboxPage = 90,

	// CUSTOMERS SECTION
	ViewUnverifiedCustomersTab = 100,
	CompleteQuoteAction = 105,
	ViewVerifiedCustomersTab = 110,
	AddNewCustomerAction = 115,
	ViewCustomerAction = 120,
	ViewFullSSN = 125,
	SkipIdentityVerification = 130,
	PerformIdentityVerification = 135,
	ViewRedFlags = 140,
	ViewCreditReport = 145,
	ViewHousingAndEmploymentInfo = 150,
	ViewQuotesTable = 155,
	CreateNewQuoteAction = 160,
	ViewDealsTable = 165,
	AllowCustomerMeetings = 170,

	// DEALS SECTION
	ViewQuotesTab = 200,
	ViewDealsTab = 205,
	ConvertQuoteToDeal = 210,
	AllowToResolveApprovalRequests = 211,
	ViewCustomerInformation = 215,
	ViewVehicleInformation = 220,
	ViewTradeInInformation = 225,
	ViewRegistrationAndTitling = 230,
	ViewPurchaseFigures = 235,
	SendDealBackToSalesPerson = 240,
	SendDealBackToSalesManager = 245,
	SendDealBackToFIManager = 250,
	SendDealBackToFIAdmin = 255,
	ViewInsuranceInformation = 260,
	AccessFIMenu = 265,
	ViewDealRecap = 270,
	ViewDealJacket = 275,
	AccessFIAdmin = 280,
	ViewPosting = 285,
	PerformDealAudit = 290,

	// CANCEL COVERAGE SECTION
	CreateCancellation = 300,
	EditCancellation = 305,
	ViewCancellation = 310,

	// SERVICE LOOKUP SECTION
	AccessServiceLookup = 400,

	// REPORTS SECTION
	AccessCreditReport = 500,
	AccessFIReport = 505,
	AccessDealsReport = 510,

	// SETTINGS SECTION
	ManageUsers = 600,
	ManageAccountingSettings = 605,
	ManageStoreSettings = 610,

	// UTILITIES SECTION
	CanBroadcast = 700,
	CanSendMassEmail = 705,
	CanSendMassText = 710,

	// CHECKLIST ITEMS
	SalesPersonChecklist = 800,
	SalesManagerChecklist = 805,
	FIManagerChecklist = 810,
	FIAdminChecklist = 815,
	CostingClerkChecklist = 820,
	TitlingChecklist = 825,

	// SPECIAL PERMISSIONS
	// AllowSaturnAccess = 1000,
	// AllowRemoteDealMeetings = 1010,
	// AllowDealActivation = 1020,
	AccessCashBash = 1030,
	CanNotarize = 1040,
}

export enum Department {
	Sales = 0,
	FinanceAndInsurance = 1,
	Accounting = 2,
	Service = 3,
	Management = 4,
	Headquarters = 100,
}

export enum SaturnPermissionType {
	Pages = 0,
	Customers = 1,
	Deals = 2,
	CancelCoverage = 3,
	ServiceLookup = 4,
	Reports = 5,
	Settings = 6,
	Utilities = 7,
	Checklist = 8,
	Other = 9,
}

export enum DealStatuses {
	Dead = 5,
	SalesInProcess = 400,
	SalesFinished = 450,
	SalesManagerInProcess = 500,
	SalesManagerFinished = 550,
	FiInProcess = 600,
	FiFinished = 650,
	FiAdminInProcess = 660,
	FiAdminFinished = 661,
	AccountingInProcess = 700,
	AccountingFinished = 750,
	Finalized = 10000,
}

export enum CDKDealStatus {
	Unknown = 0,
	Booked = 66, //B
	Cancelled = 67, //C
	Finalized = 70, //F
	Intermediate = 73, //I
	Pending = 80, //P
	Unwind = 85, //U
}

export enum DepartmentRoles {
	None = '',
	Sales = 'Sales',
	FI = 'F&I',
	SalesPeople = 'Sales Person',
	SalesManagement = 'Sales Manager',
	FiManagement = 'F&I Manager',
	FiAdministration = 'F&I Administrator',
	Accounting = 'Costing Clerk',
}

export enum BookValue {
	Default = 0,
	Manufacturer = 5,
	JDPowers = 10,
	KBB = 20,
	BlackBook = 30,
	MMR = 40,
	Galves = 50,
}

export enum DriveTrain {
	// FrontWheelDrive = "Front Wheel Drive",

	// RearWheelDrive = "Rear Wheel Drive",

	// AllWheelDrive = "All Wheel Drive",

	// FourWheelDrive = "Four Wheel Drive",
	FrontWheelDrive = 0,

	RearWheelDrive = 1,

	AllWheelDrive = 2,

	FourWheelDrive = 3,
	Galves = 50,
}

/**
 *  We save  the FIMenuDealClass in multiple ways and places.
 *  Sometimes is a copy of a credit application, an actual deal or a quote.
 */
export enum DealKind {
	Quote,
	Deal,
	CreditApplication,
}

export enum FeeSource {
	Saturn = 0,
	Government = 1,
	Lender = 2,
}

export enum CreditBureaurs {
	Equifax = 0,
	Experian = 1,
	TransUnion = 2,
	Ofac = 20,
	MLA = 21,
}

export enum FIProductType {
	Other = 999,
	ServiceContract = 1,
	Maintenance = 2,
	TitaniumBundle = 10,
	Appearance = 13,
	Towbuster = 7,
	Etch = 14,
	Skylink = 8,
	Gap = 9,
	ExcessWearAndTear = 4,
	DingAndDent = 3,
	TireAndWheel = 5,
	KeyAndRemote = 6,
	CatalyticConverter = 15,
	TotalLossProtection = 16,
}

export enum PartnerCodeType {
	USWarrantyCompanyCode = 10,
	USWarrantyStoreCode = 20,
	NSDCode = 30,
	GWCCode = 40,
	CommodoreCode = 50,
	CaltexCode = 60,
	PENDealerID = 100,
	PENCornerstone = 110,
	RouteOneDealerId = 200,
	RouteOnePartnerId = 210,
	MScanAccount = 300,
	CarFaxPartnerCode = 400,
	CarFaxUIDCode = 401,
	CBCCustomerID = 500,
	CBCMasterID = 501,
	CBCMasterPassword = 502,
	CBCUserID = 503,
	CBCPassword = 504,
	DialpadUserId = 70,
	SpireonAccountId = 80,
	DLPDealerId = 90,
	AutoCompleteDealerID = 600,
	DDIPartnerId = 700,
	DDIDealerId = 701,
}

export enum PartnerPaperworkMethod {
	Default = 0,
	Internal = 1,
	API = 2,
	InternalAndAPI = 3,
}

export enum CBCCreditPullVersions {
	SCORE_8_EFX_F = 0,
	SCORE_5_EFX_F = 1,
	AUTO_8_EFX_F = 2,
	AUTO_9_EFX_F = 3,
	AUTO_8_EFX_N = 4,
	SCORE_8_EFX_N = 5,
	AUTO_5_EFX_N = 6,
	SCORE_5_EFX_N = 7,
	AUTO_5_EFX_F = 8,
	SCORE_9_EFX_N = 9,
	SCORE_9_EFX_F = 10,
	AUTO_9_EFX_N = 11,
	AUTO_SCORE_V9_XPN = 12,
	AUTO_V3_XPN = 13,
	ADVANCED_XPN = 14,
	ADVANCED_V2_XPN = 15,
	BANKCARD_V8_XPN = 16,
	CLASSIC_V9_RISK_SCORE_XPN = 17,
	RISK_V3_XPN = 18,
	RISK_V2_XPN = 19,
	AUTO_V2_XPN = 20,
	AUTO_V8_XPN = 21,
	RISK_V8_XPN = 22,
	AUTO_SCORE_9_TU = 23,
	AUTO_SCORE_98_TU = 24,
	AUTO_SCORE_4_TU = 25,
	SCORE_9_TU = 26,
	SCORE_4_TU = 27,
	AUTO_SCORE_8_TU = 28,
	SCORE_8_TU = 29,
	SCORE_98_TU = 30,
	AUTO_SCORE_9_XT_TU = 31,
}

export enum CreationSource {
	Unknown = 0,
	CreditApplication = 1,
	CustomersPage = 2,
	FIMenuDeal = 3,
	CreditPull = 4,
	IdentityVerification = 5,
}

export enum RedFlagsStatus {
	Blank = 0, // If never credit run.
	NoRedFlags = 1, // Flags came in all good.
	PendingRedflags = 2, // Has Redflags
	ClearedRedflags = 3,
}

export enum PlaidVerificationStatus {
	Active = 0,
	Success = 1,
	Failed = 2,
	Expired = 3,
	Canceled = 4,
	PendingReview = 5,
}

export enum CustomerApplicationStatus {
	Created = 0,
	PartiallyCompleted = 10,
	CompletedNoCredit = 20,
	Completed = 30,
}

export enum UserProvideMappingType {
	DDIPassword = 0,
	DDIUsername = 1,
}

export const UserProvideMappingTypeDisplay = {
	[UserProvideMappingType.DDIPassword]: 'DDI Password',
	[UserProvideMappingType.DDIUsername]: 'DDI Username/Email',
};

export enum VehiclePrimaryUsage {
	PERSONAL = 0,
	FAMILY = 1,
	HOUSEHOLD = 2,
	BUSINESS = 3,
	AGRICULTURAL = 4,
	OTHER = 5,
	WHOLESALE = 6,
	EXPORT = 7,
}

export enum VehicleDeliveryMethods {
	Delivery = 0,
	DrivenOffLot = 1,
	DeliveryOutOfState = 2,
	Export = 3,
}

export enum LanguageCode {
	English = 'en',
	Spanish = 'es',
}

export enum StateCode {
	AL = 'AL',
	AK = 'AK',
	AZ = 'AZ',
	AR = 'AR',
	CA = 'CA',
	CO = 'CO',
	CT = 'CT',
	DE = 'DE',
	DC = 'DC',
	FL = 'FL',
	GA = 'GA',
	HI = 'HI',
	ID = 'ID',
	IL = 'IL',
	IN = 'IN',
	IA = 'IA',
	KS = 'KS',
	KY = 'KY',
	LA = 'LA',
	ME = 'ME',
	MD = 'MD',
	MA = 'MA',
	MI = 'MI',
	MN = 'MN',
	MS = 'MS',
	MO = 'MO',
	MT = 'MT',
	NE = 'NE',
	NV = 'NV',
	NH = 'NH',
	NJ = 'NJ',
	NM = 'NM',
	NY = 'NY',
	NC = 'NC',
	ND = 'ND',
	OH = 'OH',
	OK = 'OK',
	OR = 'OR',
	PA = 'PA',
	RI = 'RI',
	SC = 'SC',
	SD = 'SD',
	TN = 'TN',
	TX = 'TX',
	UT = 'UT',
	VT = 'VT',
	VA = 'VA',
	WA = 'WA',
	WV = 'WV',
	WI = 'WI',
	WY = 'WY',
}

export enum StateDescription {
	AL = 'Alabama',
	AK = 'Alaska',
	AZ = 'Arizona',
	AR = 'Arkansas',
	CA = 'California',
	CO = 'Colorado',
	CT = 'Connecticut',
	DE = 'Delaware',
	DC = 'District Of Columbia',
	FL = 'Florida',
	GA = 'Georgia',
	HI = 'Hawaii',
	ID = 'Idaho',
	IL = 'Illinois',
	IN = 'Indiana',
	IA = 'Iowa',
	KS = 'Kansas',
	KY = 'Kentucky',
	LA = 'Louisiana',
	ME = 'Maine',
	MD = 'Maryland',
	MA = 'Massachusetts',
	MI = 'Michigan',
	MN = 'Minnesota',
	MS = 'Mississippi',
	MO = 'Missouri',
	MT = 'Montana',
	NE = 'Nebraska',
	NV = 'Nevada',
	NH = 'New Hampshire',
	NJ = 'New Jersey',
	NM = 'New Mexico',
	NY = 'New York',
	NC = 'North Carolina',
	ND = 'North Dakota',
	OH = 'Ohio',
	OK = 'Oklahoma',
	OR = 'Oregon',
	PA = 'Pennsylvania',
	RI = 'Rhode Island',
	SC = 'South Carolina',
	SD = 'South Dakota',
	TN = 'Tennessee',
	TX = 'Texas',
	UT = 'Utah',
	VT = 'Vermont',
	VA = 'Virginia',
	WA = 'Washington',
	WV = 'West Virginia',
	WI = 'Wisconsin',
	WY = 'Wyoming',
}

export enum PlateTransactionType {
	None = 0,
	Transfer = 10,
	NewTempPlate = 20,
	NewMetal = 30,
	Replacement = 40,
	Salvage = 50,
}
export enum VehicleInquiryReason {
	VehicleDriverSafetyAndThe = 2,
	VerifyInformation = 3,
	WrittenConsentOfOwner = 13,
	useAuthorizedByAState = 14,
}
export enum MessageType {
	ImportedSuccessfully = 3001,
	SentToQA = 3002,
	ValidationError = 3003,
	QARejection = 3004,
	FinalizeSuccessful = 3005,
	TransactionVoidedStatusSubmitted = 3006,
	TransactionVoidedStatusPending = 3007,
	TransactionVoidedStatusCancelled = 3008,
	TransactionCancelledStatusCancelled = 3009,
	ErrorVoiding = 3010,
	AddressChangeSubmitted = 3011,
	AddressChangeSubmittedError = 3012,
	NameChangeSubmitted = 3013,
	NameChangeSubmittedError = 3014,
	ReplacementTitleSubmitted = 3015,
	ReplacementTitleSubmittedError = 3016,
	DealSubmittedToState = 3017,
	DealSubmittedToStateError = 3018,
	AmendmentSubmittedToState = 3019,
	AmendmentSubmittedToStateError = 3020,
	TempTagSubmittedToState = 3021,
	TempTagSubmittedToStateError = 3022,
	DealCompleted = 3023,
}
export enum DDITitleType { // We could use a more generic enum.
	PrintOnDemand, // None
	ManufacturerStatementOfOrigin, // Original New
	OutOfStateUsed, // Out-of-state Transfer - (Original Used)
	InStateTransferUsed, // In-state Transfer - (In State Used)
}
export enum DDIFlagsType {
	Clear,
	Warning,
	NoResult,
	Error,
	Indeterminate,
}

export enum WalkAwayPayeeType {
	Lender = 0,
	Customer = 1,
	CoCustomer = 2,
}

export enum VehicleTitledUnder {
	Customer,
	CoCustomer,
	Both,
}

export enum LenderUseType {
	Lease = 0,
	Retail = 1, //Finance
	Draft = 2, //Cash
}

export enum OverlayTypes {
	TextBox = 1,
	Image = 2,
	Signature = 3,
	Field = 4,
	Initials = 5,
	NotaryStamp = 6,
}

export enum TextAlignments {
	AlignLeft = 0,
	AlignCenter = 1,
	AlignRight = 2,
	AlignJustified = 3,
	AlignTop = 4,
	AlignMiddle = 5,
	AlignBottom = 6,
	AlignBaseline = 7,
	AlignJustifiedAll = 8,
}

export enum DealTypeEnum {
	Cash = 0,
	Finance = 1,
	Lease = 2,
}

export enum DealType {
	Lease = 'Lease',
	Retail = 'Finance',
	Draft = 'Draft',
}

export enum FinanceChannelsProvider {
	None = 0,
	RouteOne = 10,
	DealerTrack = 20,
}

export enum InventoryType {
	New = 'New',
	Used = 'Used',
	Certified = 'Certified',
}

export enum USBVendorID {
	ProlificTechnologyInc = 0x067b,
	Logitech = 0x046d,
}

export enum USBProductID {
	PL2305ParallelPort = 0x2305,
	USBKeyboard = 0xc31c,
}

export enum USBClassCode {
	UseInterfaceDescriptor = 0x00,
	Audio = 0x01,
	Communications = 0x02,
	HID = 0x03,
	Physical = 0x05,
	StillImaging = 0x06,
	Printer = 0x07,
	MassStorage = 0x08,
	Hub = 0x09,
	CDCData = 0x0a,
	SmartCard = 0x0b,
	ContentSecurity = 0x0d,
	Video = 0x0e,
	PersonalHealthcare = 0x0f,
	AVDevice = 0x10,
	BillboardDevice = 0x11,
	TypeCBridgeDevice = 0x12,
	USBBulkDisplayProtocolDevice = 0x13,
	MCTPOverUSBProtocolEndpointDevice = 0x14,
	I3CDevice = 0x3c,
	DiagnosticDevice = 0xdc,
	WirelessController = 0xe0,
	Misc = 0xef,
	ApplicationSpecific = 0xfe,
	VendorSpecific = 0xff,
}

export enum AmountType {
	Currency = 0,
	Percentage = 1,
	MoneyFactor = 2,
}

export enum RebateType {
	ConsumerCash = 0,
	DealerCash = 1,
	Residual = 2,
	Rate = 3,
}

export function getEnumDisplayText<T>(enumType: T, value: number): string {
	const enumList = enumToList(enumType);
	return enumList.find(item => item.value === value)?.display;
}

/** Type of business */
export enum EntityType {
	Unknown = -1,
	Corporation = 0,
	LLC = 1,
	Partnership = 2,
	Proprietor = 3,
}

export enum BusinessLocationOwnershipStatus {
	Mortgage = 'mortgage',
	Rental = 'rental',
	Own = 'own',
}

/** for garage cars */
export enum OwnerRelationshipType {
	Other = 0,
	Personal = 1,
	Household = 2,
	Sold = 3,
}

export enum CSharpType {
	Int16 = 'Int16',
	Int32 = 'Int32',
	Int64 = 'Int64',
	Single = 'Single',
	Double = 'Double',
	Decimal = 'Decimal',
	Boolean = 'Boolean',
	DateTime = 'DateTime',
	Function = 'Func`1',
	MetadataSingleSelect = 'Metadata_SingleSelect`1',
	MetadataMultiSelect = 'Metadata_MultiSelect`1',
	String = 'String',
}

export enum InputComponent {
	Textbox = 'InputTextbox',
	Number = 'InputNumber',
	Currency = 'InputCurrency',
	Checkbox = 'InputCheckbox',
	Radio = 'InputRadio',
	Date = 'InputDate',
	File = 'InputFile',
	Dropdown = 'InputDropdown',
	MultiSelectDropdown = 'InputMultiSelectDropdown',
	RichDropdown = 'InputRichDropdown',
}

export enum DealChecklistType {
	Other = 0,
	Upload_Image = 1,
	Upload_File = 2,
	VisitLink = 3,
	LaunchPlaid_IDV = 10,
	LaunchPlaid_BankIncome = 11,
	LaunchPlaid_PayrollIncome = 12,
	LaunchPlaid_AssetReport = 13,
	LaunchPlaid_Statements = 14,
	//Transfer_PlaidBankTransfer = CHECKLIST_TYPE.Transfer_PlaidBankTransfer,
}

////////////////////////////////////////////////
//////////////////*Accounting*//////////////////
////////////////////////////////////////////////

export enum AccountingSettingsLevel {
	Store = 0,
	Category = 1,
	AccountingItem = 2,
	AccountingNumber = 3,
}

export enum AccountingTransactionTypes {
	Post = 200,
	Adjustment = 300,
	Chargeback = 400,
	Reversal = 1000,
}

export enum AccountingValueCategory {
	Ignored = -100, //FRONT-END ONLY
	Deprecated = -1,
	Other = 0,
	Fees = 10,
	Additions = 20,
	Products = 30,
	TradeIns = 40,
	PurchaseFigures = 50,
	Cancellations = 60,
	CarCalcsTitleIds = 70,
	Taxes = 80,
	Funding = 90,
	Commissions = 95,
	Custom = 100,
}

export enum CustomersRelationship {
	Other = 0,
	Spouse = 10,
	ResidesWith = 20,
	Parent = 30,
	Guarantor = 40,
	CoApplicant = 50,
}

export enum TitleStatus {
	NotReadyForTitleWork = 100,
	ReadyForTitleWork = 200,
	StartedTitleWork = 300,
	SentTitleToTagAgency = 400,
	Problem = 500,
	Reverify = 550,
	DoneTitleWork = 600,
	WaitingOnTitle = 700,
}

export enum PaperworkStatus {
	Error = 0,
	PartiallyActivated = 1,
	NotActivated = 2,
	Activated = 3,
	VoidedError = 4,
	Voided = 5,
	NoPaperwork = 6,
}

export enum PaymentMethods {
	Cash = 0,
	DebitCard = 10,
	CreditCard = 20,
	BankTransfer = 30,
	PaperCheck = 40,
	ProductCancellationRefund = 50,
	CashierCheck = 60,
	WireTransfer = 70,
	ChargedCard = 80,
	BankCard = 90,
}

export enum EVALUATION_MODE {
	CSHARP = 'C#',
	JAVASCRIPT = 'JS',
}

export enum VariableListType {
	ReserveProfits = 1,
	Accounting = 2,
}

export enum DataModel {
	Paperwork = 0,
	Settings = 1,
	Checklist = 2,
	Accounting = 3,
	Lender = 4,
	Cancellation = 5,
	BuyersOrder = 6,
	ELead = 7,
	FinanceChannels = 8,
	PartnerCodes = 9,
	Global = 999,
}

export enum ProfitFlags {
	None = -1,
	Front = 0,
	Back = 1,
	Dealer = 2,
}

export enum FIMenuSection {
	Unknown = -1,
	Customer = 0,
	Vehicle,
	TradeIn,
	DealDetails,
	Insurance,
	Purchase,
	Lender,
	FIMenu,
	DealJacket,
	Registration,
	DealRecap,
	DealAudit,
	FIAdmin,
	Posting,
	FinalizedFI = 100,
}

export enum CustomerType {
	Customer,
	Lead,
}

export enum AccountingAmountOverrideType {
	NO_CHANGE = 0,
	SWITCH_SIGN = 10,
	MAKE_POSITIVE = 20,
	MAKE_NEGATIVE = 30,
	EXPRESSION_OVERRIDE = 40,
}

export const AccountingAmountOverrideTypes: Record<AccountingAmountOverrideType, string> = {
	[AccountingAmountOverrideType.NO_CHANGE]: 'No Change',
	[AccountingAmountOverrideType.SWITCH_SIGN]: 'Switch Sign',
	[AccountingAmountOverrideType.MAKE_POSITIVE]: 'Make Positive',
	[AccountingAmountOverrideType.MAKE_NEGATIVE]: 'Make Negative',
	[AccountingAmountOverrideType.EXPRESSION_OVERRIDE]: 'Expression Override',
};

export enum Month {
	January = 0,
	February = 1,
	March = 2,
	April = 3,
	May = 4,
	June = 5,
	July = 6,
	August = 7,
	September = 8,
	October = 9,
	November = 10,
	December = 11,
}
export enum DropdownSortMode {
	Ascending = 0,
	Descending = 1,
	Custom = 2,
	OriginalOrder = 3,
}

export enum PaperworkDocumentStatus {
	ErrorGenerating = 10,
	ReadyToBeSigned = 20,
	SigningInProgress = 25,
	PartiallySigned = 28,
	Signed = 30,
	ErrorVoiding = 40,
	Voided = 50,
	ErrorActivating = 60,
}

export enum OilType {
	NA = -1,
	Regular = 0,
	Blend = 2,
	Synthetic = 1,
	Diesel = 3,
}

export enum StoreFileTypes {
	MainLogo = 0,
}

export enum CustomerTriggers {
	OpenVideo = 1,
	PaymentSheet = 2,
	Paperwork = 3,
	PaperworkScreen = 4,
	FIManagerConnected = 5,
	Information = 6,
	UpdateFIMenu = 7,
	LoadNextDocument = 8,
	InvokeClickedToSign = 9,
}

export enum FIManagerTriggers {
	CustomerConnected = 1,
	UpdateFIMenu = 2,
}

export enum Language {
	English = 0,
	Spanish = 1,
}

export enum Sounds {
	TermsOfCoverage = 1,
	PaymentStartDate = 2,
	SelectPayment = 3,
}

export enum PersonType {
	Customer = 1,
	CoCustomer = 2,
	FIManager = 3,
	Unknown = 4,
	Accounting = 5,
}

export enum CustomerViews {
	Reset = 1,
	VideoPresentation = 2,
	PaymentSheetPage = 3,
	PaperworkPage = 4,
	PresentationPage = 5,
	GraphPage = 6,
	PaymentSheetPreferredCoverage = 7,
	PaymentSheetPaymentStart = 8,
	PaymentSheetCarousel = 9,
	AllVideos = 10,
	PaymentSheetPrinted = 11,
	FirstVideoViewed = 12,
	VideosSeen = 13,
	PaymentSheetPreferredCoverageFinished = 14,
	PaymentSheetPaymentStartDateFinished = 15,
	PaymentSheetCarouselFinished = 16,
	MeetingRoomCreation = 17,
	Connected = 20,
	Waiting = 21,
	DocSign = 22,
	AllSign = 23,
	PreferredCoverageTermSelected = 24,
	DaysToNextPaymentSelected = 25,
	Opening = 26,
	Processing = 27,
	Information = 28,
}

export enum VideosSeen {
	NoCoverageLeft = 1,
	PowerTrainOnly = 2,
	BumperToBumper = 3,
	RoadsideLoaners = 4,
	RoadsideNoLoaners = 5,
	NoRoadsideLoaners = 6,
	NoRoadsideNoLoaners = 7,
	Loaners = 8,
	NoLoaners = 9,
	Fourth = 10,
	Fifth = 11,
	Sixth = 12,
	Seventh = 13,
	Eighth = 14,
	Leasing = 15,
	Ninth = 16,
	Gap = 17,
	NoGap = 18,
	Eleventh = 19,
	Disclaimer = 20,
}

export enum CBCReportTypes {
	EFX = 0,
	XPN = 1,
	TU = 2,
	XPN_EFX = 3,
	TU_EFX = 4,
	XPN_TU = 5,
	XPN_TU_EFX = 6,
	OFAC = 20,
	MLA = 21,
}

export enum SaturnCreditBureaus {
	Equifax = 0,
	Experian = 1,
	TransUnion = 2,
	Ofac = 20,
	MLA = 21,
}

export enum CreditReportReportMessagesCodes {
	Unknown = 0,
	MLACoveredBorrower = 1,
	NonMLACoveredBorrower = 2,
	MLATempUnavailable = 3,
	MLANotAllowed = 4,
	MLANotPerformed = 5,
}

export enum CreditReportBureauErrorCode {
	Unknown = 0,
	OfacNA = 1,
	BureauFrozen = 2,
	ConsumerMinor = 3,
	SSNRequired = 4,
}

export enum CreditReportFlagTypes {
	OFAC = 0,
	Address = 1,
	SSN = 2,
	Fraud = 3,
	DOB = 4,
	MLA = 5,
}

export enum SSNTypes {
	SSN = 0,
	ITIN = 1,
}

export enum PaperworkDocumentTypes {
	PaperworkDocument = 0,
	Test = 1,
	KahuServiceAgreement = 2,
	AcceptDecline = 3,

	USWarrantyVsc = 4,
	USWarrantyMaintenance = 5,
	USWarrantyEtch = 6,
	USWarrantyTitanium = 7,
	USWarrantyVscWithMaintenance = 8,
	USWarrantyTitaniumDingAndDent = 31,
	USWarrantyTitaniumTireAndWheel = 32,
	USWarrantyTitaniumKeyAndRemote = 33,

	CommodorePaint = 9,

	CalTexPaint = 10,

	GWCService = 11,

	PENService = 12,
	PENMaintenance = 13,
	PENTitanium = 14,
	PENAppearance = 15,
	PENWear = 16,
	PENTowbuster = 17,
	PENEtch = 18,
	PENLoJack = 19,
	PENGap = 20,
	PENDingAndDent = 21,
	PENTireAndWheel = 22,
	PENKeyAndRemote = 23,

	DLPTowbuster = 24,
	DLPEtch = 25,
	DLPGap = 26,
	DLPCatalyticConverter = 27,
	DLPTotalLossProtection = 28,
	DLPWear = 29,
	DLPService = 30,

	NSDPaint = 233,
	NSDTitanium = 270,
	NSDTheft = 272,
	NSDTowbuster = 280,
	NSDWear = 284,
	NSDGap = 285,

	CarFax = 300,

	RouteOne = 350,

	Trades = 998,

	Other = 999,
}

export enum ReasonOfCancellation {
	CustomerRequest = 1,
	Refinancing = 2,
	TradeInForNewVehicle = 3,
	Repossession = 4,
	VehicleSold = 5,
	TotalLoss = 6,
	TradeInAtDifferentDealership = 7,
	LenderRequest = 8,
}

export enum CancellationEventType {
	VideoEvent = 1,
	DocumentEvent = 2,
	FormEvent = 3,
	EmailEvent = 4,
}

export enum VideoId {
	Introduction = 1,
	ServiceContract = 2,
	Maintenance = 3,
	PaintlessDingAndDent = 4,
	ExcessWearAndTear = 5,
	TireAndWheelProtection = 6,
	KeyAndRemoteCoverage = 7,
	TowBuster = 8,
	TraceableTheftProtection = 14,
	GAPProtection = 10,
	Lienholder = 11,
	CancellationRefundCalculation = 12,
	FinalVideo = 13,
}

export enum CancellationDocumentType {
	CancellationInstructions = 1,
	CancellationPacket = 2,
}

export enum CancellationFormType {
	Default = 1,
	Freestyle = 2,
}

export enum EmailType {
	CustomerInstructionsEmail = 1,
	DownloadCancellationFormEmail = 2,
}

export enum CDKMappingLocation {
	Products = 1,
	Fees = 2,
	Taxes = 3,
	Weows = 4,
}

export enum LogWhat {
	Started = 'Started',
	Finished = 'Finished',
	StepStarted = 'Step Started',
	StepFinished = 'Step Finished',
	StepChanged = 'Step Changed',
	Failed = 'Failed',
	Disconnected = 'Disconnected',
}

export enum FuelTypes {
	Gasoline = 1059,
	Hybrid = 1152,
	PluginHybrid = 1307,
	Electric = 1167,
	Diesel = 1058,
	Propane = 1057,
	NaturalGas = 1209,
	GasolinePropane = 1217,
	GasolineNaturalGas = 1218,
	FuelFlex = 1213,
	FuelFlexHybrid = 1306,
	FuelFlexPluginHybrid = 1308,
	Hydrogen = 1345,
	PluginHybridFastCharge = 1349,
}

export enum BodyTypes {
	SUV = 13,
	Minivan = 14,
	CargoVan = 15,
	FourDoorSedan = 2,
	StationWagon = 7,
	TwoDoorCoupe = 1,
	Convertible = 6,
	Hatchback = 20,
	ThreeDoorCar = 41,
	RegularCabPickup = 3,
	RegularCabChassisCab = 10,
	ExtendedCabPickup = 4,
	ExtendedCabChassisCab = 11,
	CrewCabPickup = 5,
	CrewCabChassisCab = 12,
	FullSizePassengerVan = 16,
	FullSizeCargoVan = 17,
	SpecialtyVehicle = 18,
	StepsideBed = 19,
	LongBedTruck = 8,
	ShortBedTruck = 9,
	StandardBedTruck = 39,
}

export enum AddressType {
	Mail = 0,
	Registration = 1,
	Garage = 2,
	Customer = 3,
	CoCustomer = 4,
	Lender = 10,
}

export enum VehicleMileageStatus {
	ActualMileage = 0,
	ExcessOfMechanicalLimits = 1,
	NotActualMileage = 2,
}

export enum VehicleSurcharges {
	Commercial = 0,
	LiftKit = 1,
	FourWheelDrive = 2,
	Supercharged = 3,
	Turbo = 4,
}

export enum WarrantyExpirationDateRules {
	Today = 0,
	InServiceDate = 1,
	ModelYear = 2,
}

export enum WarrantyExpirationMilesRules {
	NoExpiration = 0,
	FromOdometer = 1,
	FromZero = 2,
}

export enum CreditAppResidenceStatus {
	Mortgage = 1,
	Rental = 2,
	Own = 3,
	Other = 4,
}

export enum CreditAppEmploymentStatus {
	Employee = 1,
	Retired = 2,
	Student = 3,
	Unemployed = 4,
	Other = 5,
}

export enum CreditAppTypeEmployee {
	Military = 'military',
	W2 = 'w2',
	SE1099 = '1099',
}

export enum CustomerApplicationEmploymentStatus {
	Employed = 'employed',
	Retired = 'retired',
	Disabled = 'disabled',
	Student = 'student',
	Unemployed = 'unemployed',
	Other = 'other',
}

export enum CustomerApplicationHousingStatus {
	Mortgage = 'mortgage',
	Rental = 'rental',
	Own = 'own',
	Other = 'familyOther',
}

export enum CustomerApplicationEnterpriseType {
	LLC = 'llc',
	Corporation = 'corporation',
	Partnership = 'partnership',
	Proprietor = 'proprietor',
}

export enum CreditAppButtonsActions {
	SaveAnswer = 1,
	NextQuestion = 2,
	SaveMultiAnswer = 3,
	CallApi = 4,
	SaveFullApplication = 5,
}

export enum CustomerIdentificationTypes {
	DriversLicense = 1,
	InsuranceId = 2,
	Passport = 3,
	GovernmentAgencyId = 4,
	SchoolId = 5,
	TeacherId = 6,
	MilitaryId = 7,
	VeteranId = 8,
	EmployeeId = 9,
	UnionId = 10,
	AssociationId = 11,
	VehicleRegistration = 12,
	UtilityBill = 13,
	PayStub = 14,
	SocialSecurityCard = 15,
	GreenCard = 16,
	ResidentAlienCard = 17,
}

export enum DealEmployeeRoleTypes {
	SalesManager = 10,
	SalesPerson1 = 11,
	FloorCloser = 12,
	SalesPerson2 = 13,
	FiManager = 20,
	AfterMarketSalesManager = 30,
	AfterMarketSalesPerson = 31,
	CostingClerk = 40,
	AccountingManager = 41,
	Controller = 42,
	Ripper = 43,
}

export enum PricingPlanSelectors {
	Other = 999,
	HighestPrice = 10,
	LowestPrice = 20,
}

export enum PricingListOptionPriceSplits {
	HighestBetween = 10,
	LowestBetween = 20,
}

export enum ProfitMethods {
	AmountMinusCost = 1,
	CostMinusAmount = 2,
}

export enum AdditionTypes {
	PhysicalAddition = 1,
	MonetaryAddition = 2,
	Other = 0,
}

export enum PayoffQuoteInquiryTypeProductType {
	Retail = 0,
	Lease = 1,
	Balloon = 2,
}

export enum PayoffQuoteInquiryTypeInquiryType {
	ACC = 0,
	SSN = 1,
	VIN = 2,
}

export enum RatingStatus {
	UpToDate = 0,
	Required = 1,
	RequiredWithSurchargeChange = 2,
}

export enum TextMessagingProviders {
	Twilio = 0,
	DialPad = 1,
}

export enum CancelCoverageStatus {
	Undefined = 0,
	CancellationRequested = 100,
	VideosWatchedSome = 200,
	VideosWatchedAll = 300,
	PacketReceived = 400,
	PacketSubmitted = 500,
	CancellationPacketIncomplete = 600,
	CancellationPacketReceived = 700,
	CancellationProcessed = 800,
	CancellationCompleted = 900,
	RefundSent = 1000,
}

export enum CancelCoverageApplyFundsTo {
	ToLienholder = 1,
	TowardsDownPayment = 2,
	ToCustomer = 3,
}

export enum AuditTrailOperations {
	Insert = 1,
	Update = 2,
	Delete = 3,
}

export enum CustomerDocumentType {
	Identification = 10,
	Income = 20,
	Rebate = 30,
	Other = 40,
}

export enum CustomerDocumentSubtype {
	DriversLicense = 10,
	InsuranceId = 20,
	Passport = 30,
	GovernmentAgencyId = 40,
	SchoolId = 50,
	TeacherId = 60,
	MilitaryId = 70,
	VeteranId = 80,
	EmployeeId = 90,
}

export enum DealRoomState {
	DoesntExist = 0,
	EditorVacancy = 1,
	ActiveEditor = 2,
}

export enum DealGoalTypes {
	ProductCount = 0,
	PackageCount = 1,
	ProductProfit = 2,
}

export enum DealLoJackStatus {
	Installed = 0,
	NeedsActivation = 1,
	NotInstalled = 2,
	Unknown = 3,
}

export enum ComparisonType {
	Minimum = 0,
	Tween = 1,
	Maximum = 2,
}

export enum RTFileType {
	Excel = 0,
	Pdf = 1,
	Csv = 2,
}

export enum PlaidProducts {
	Assets = 'assets',
	Auth = 'auth',
	Identity = 'identity',
	IdentityVerification = 'identity_verification',
	Transfer = 'transfer',
	IncomeVerification = 'income_verification',
	Statements = 'statements',
}

export enum PlaidLanguages {
	Danish = 'da',
	Dutch = 'nl',
	English = 'en',
	Estonian = 'et',
	French = 'fr',
	German = 'de',
	Italian = 'it',
	Latvian = 'lv',
	Lithuanian = 'lt',
	Norwegian = 'no',
	Polish = 'pl',
	Portuguese = 'pt',
	Romanian = 'ro',
	Spanish = 'es',
	Swedish = 'se',
}

export enum PlaidCountries {
	UnitedStates = 'US',
	Canada = 'CA',
}

export enum PlaidIdTypes {
	ArgentinaDNI = 'ar_dni',
	AustraliaDrivers = 'au_drivers_license',
	AustraliaPassport = 'au_passport',
	BrazilCPF = 'br_cpf',
	CanadaSIN = 'ca_sin',
	ChileRUN = 'cl_run',
	ChinaResident = 'cn_resident_card',
	ColombiaNIT = 'co_nit',
	DenmarkCPR = 'dk_cpr',
	EgyptNationalID = 'eg_national_id',
	SpainDNI = 'es_dni',
	SpainNIE = 'es_nie',
	HongKongHKID = 'hk_hkid',
	IndiaPAN = 'in_pan',
	ItalyCF = 'it_cf',
	JordanCivilID = 'jo_civil_id',
	JapanMyNumber = 'jp_my_number',
	KenyaHudumaNamba = 'ke_huduma_namba',
	KuwaitCivilID = 'kw_civil_id',
	MexicoCURP = 'mx_curp',
	MexicoRFC = 'mx_rfc',
	MalaysiaNRIC = 'my_nric',
	NigeriaNIN = 'ng_nin',
	NewZealandDrivers = 'nz_drivers_license',
	OmanCivilID = 'om_civil_id',
	PhilippinesPSN = 'ph_psn',
	PolandPESEL = 'pl_pesel',
	RomaniaCNP = 'ro_cnp',
	SaudiArabiaNationalID = 'sa_national_id',
	SwedenPIN = 'sw_pin',
	Singapore = 'sg_nric',
	TurkiyeKimlik = 'tr_tc_kimlik',
	UnitedStatesSSN = 'us_ssn',
	UnitedStatesSSNLast4 = 'us_ssn_last_4',
	SouthAfricaSmartID = 'za_smart_id',
}

export enum PlaidIncomeType {
	Bank = 'bank',
	Payroll = 'payroll',
}

export enum PlaidPayrollFlow {
	DigitalIncome = 'payroll_digital_income',
	DocumentIncome = 'payroll_document_income',
}

export enum PlaidIncomeSource {
	Salary = 'SALARY',
	Unemployement = 'UNEMPLOYMENY',
	Cash = 'CASH',
	GigEconomy = 'GIG_ECONOMY',
	Rental = 'RENTAL',
	ChildSupport = 'CHILD_SUPPORT',
	Military = 'MILITARY',
	Retirement = 'RETIREMENT',
	LongTermDisability = 'LONG_TERM_DISABILITY',
	BankInterest = 'BANK_INTEREST',
	CashDeposit = 'CASH_DEPOSIT',
	TransferFromApplication = 'TRANSFER_FROM_APPLICATION',
	TaxRefund = 'TAX_REFUND',
	BenefitOther = 'BENEFIT_OTHER',
	Other = 'OTHER',
}

export enum PlaidPayType {
	Unknown = 'UNKNOWN',
	Gross = 'GROSS',
	Net = 'NET',
}

export enum PlaidPayFrequency {
	Unknown = 'UNKNOWN',
	Weekly = 'WEEKLY',
	Biweekly = 'BIWEEKLY',
	SemiMonthly = 'SEMI_MONTHLY',
	Monthly = 'MONTHLY',
	Daily = 'DAILY',
}

export enum PlaidIdvStepStatus {
	Success = 'success',
	Active = 'active',
	Failed = 'failed',
	WaitingForPrerequisite = 'waiting_for_prerequisite',
	NotApplicable = 'not_applicable',
	Skipped = 'skipped',
	Expired = 'expired',
	Canceled = 'canceled',
	PendingReview = 'pending_review',
	ManuallyApproved = 'manually_approved',
	ManuallyRejected = 'manually_rejected',
}

export enum IDVStoreSettings {
	Optional = 0,
	Required = 1,
}

export enum DocumentGenerationType {
	Paperwork = 0,
	Uploaded = 1,
}

export enum PlaidInteraction {
	Unknown = -1,
	GetIdentityVerification = 0,
	GetIdentity = 10,
	GetAccountsBalance = 20,
	GetCreditSessions = 30,
	GetBankIncome = 31,
	GetPayrollIncome = 32,
	RefreshBankIncome = 33,
	GetAuth = 40,
	CreateAssetReport = 50,
	GetAssetReport = 51,
	RefreshAssetReport = 52,
	RemoveAssetReport = 53,
	GetTransfer = 60,
	TransferEvent = 61,
	CreateTransferAuth = 62,
	CreateTransfer = 63,
	LinkSession = 70,
	WebhookItemError = 80,
	WebhookIDVStatusUpdated = 81,
	GetStatementsList = 90,
	GetIndividualWatchlistScreening = 100,
}

export enum TokenStatus {
	Revoked = -1,
	Active = 0,
	Expired = 1,
	NearlyExpired = 2,
}

/**
 * This is the equivalent of SaturnAssociationType in the backend.
 * We must rename it to SaturnAssociationType.
 */
export enum DocAssociation {
	Admin = -1,
	Other = 0,
	CustomerApplication = 1,
	Deal = 2,
	Customer = 3,
	UploadedDocument = 4,
	PaperworkDocument = 5,
	Store = 6,
	PlaidAccessToken = 10,
	PlaidTransfer = 11,
	PlaidExchange = 12,
	PlaidIDVSession = 13,
	DDIDealId = 20,
	DDIDocumentId = 21,
	DDIVehicleInquiry = 22,
	PlateTransaction = 23,
	CreditReport = 30,
	AutoCompleteExchange = 40,
	R1DocumentId = 100,
	VIN = 110,
	Plate = 111,
	Employee = 120,
	FraudCheck = 121,
	RedirectInfo = 130,
	Business = 140,
	CustomerVehicle = 150,
	/**
	 * This is an application submitted to a lender. Not a customer application(NOT PORTAL)
	 */
	CreditApplication = 160,
}

export enum R1CreditDecision {
	Approved = 'A',
	Denied = 'D',
	Condition = 'O',
	Preliminary = 'R',
	Withdrawn = 'I',
	ContractReceived = 'OT',
	Booked = 'B',
	New = 'N',
	ContractHeld = 'Held',
	ContractRejected = 'Rejected',
	Funded = 'Funded',
	AdditionalDocumentsReceived = 'Add_Received',
}

export enum DDISubmitDocumentTypes {
	AFTB = 'DHSMV Form 82040 Back',
	AFTF = 'DHSMV Form 82040 Front',
	BOS = 'Bill of Sale',
	CID = 'Customer ID',
	CWS = 'Certified Weight Slip',
	DCR = 'Death Certificate',
	DRAF = 'DHSMV Form 82994',
	FLR = 'Florida Registration',
	FLTB = 'Florida Title Back',
	FLTF = 'Florida Title Front',
	FLTR = 'DHSMV Form 82041',
	GAF = 'General Affidavit',
	IAF = 'Insurance Affidavit',
	IEF = 'DHSMV Form 82002',
	LAG = 'Lease Agreement',
	LAOS = 'Letters of Admin',
	LOG = 'Letter of Guardianship',
	LSF = 'Lien Satisfaction',
	MLO = 'Military Orders',
	MSOB = 'MSO/MCO Back',
	MSOF = 'MSO/MCO Front',
	NDA = 'DHSMV Form 82175',
	NOLB = 'DHSMV Form 82139 Back',
	NOLF = 'DHSMV Form 82139 Front',
	NOS = 'DHSMV Form 82050',
	OOSP = 'Out of State Proof of Ownership',
	OOSR = 'Out of State Registration',
	OSTB = 'Out of State Title Back',
	OSTF = 'Out of State Title Front',
	POA = 'Power of Attorney',
	POB = 'Proof of Business',
	PSTC = 'Proof of Sales Tax Credit',
	PSTE = 'Proof of Sales Tax Exemption',
	RDOC = 'Repossessed Documentation',
	SODS = 'DHSMV Form 82993',
	SPOA = 'DHSMV Form 82995',
	TAG = 'Trust Agreement',
	VAOV = 'DHSMV Form 82042',
	WIL = 'Will',
}

export enum DataFormat {
	JSON = 0,
	XML = 1,
}

export enum CustomerRetrievalStatus {
	NoApplication = 0,
	RetrieveApplicationEnabled = 1,
	RetrieveApplicationDisabled = 2,
}

export enum LenderContactType {
	CustomerService = 0,
	Payoff = 1,
	Origination = 2,
	Funding = 3,
}

export enum LenderDivisionType {
	Mailing = 0,
	Lienholder = 1,
	LossPayee = 2,
	FIProductsLienholder = 3,
	Lessor = 4,
	Payoff = 5,
	Fedex = 6,
	UPS = 7,
}

export enum RedirectType {
	Other = -1,
	CustomerChecklist = 0,
	PlaidLinkPortal = 1,
	RecoverPassword = 2,
}

export enum MeetingParticipant {
	FIManager = 0,
	Customer = 1,
	COCustomer = 2,
	Guest = 3,
}

export enum BroadcastMessageType {
	Ping = 0,
	ESignStart = 1,
	ESignComplete = 2,
	HelpReply = 20,
}

export enum LegalTermTypes {
	TermsAndConditions = 0,
	AdverseActionNotice = 1,
	PrivacyNotice = 2,
	SMSConsent = 3,
}

export enum UserAccesses {
	SalesManager = 0,
	SalesPerson = 10,
	FiManager = 1,
	GeneralManager = 2,
	ServiceManager = 3,
	Director = 4,
	Accounting = 5,
	UserManager = 6,
	Admin = 7,
}

export enum PanelCustomerSteps {
	CustomerInformation = 0,
	IdentityVerification = 1,
	RedFlags = 2,
	CreditReport = 3,
	CreditApplication = 4,
	Quotes = 5,
	Deals = 6,
}

export enum ReportTypes {
	ProductsActivationVoided = 10,
	CbcCreditPulls = 20,
	DealsReport = 30,
	TradeInsAccidentReport = 50,
}

export enum StatusTypes {
	Undefined = 0,
	Flow = 100,
	CIT = 200,
	Title = 300,
	Vehicle = 400,
	FloorPlan = 500,
}

export enum StatusPriorityOrder {
	High3 = 9,
	High2 = 8,
	High1 = 7,
	Medium3 = 6,
	Medium2 = 5,
	Medium1 = 4,
	Low3 = 3,
	Low2 = 2,
	Low1 = 1,
}

export enum StatusWeight {
	None = 0,
	MinusOne = -1,
	PlusOne = 1,
}

export enum ReportFieldTypes {
	Date = 10,
	Providers = 20,
	Products = 25,
	Stores = 30,
	Checkbox = 40,
	DealStatuses = 50,
}

export enum RichTableRangeFilterTypes {
	Numeric = 0,
	Date = 1,
	Term = 2,
}

export enum HttpStatusCode {
	Processing = 102,
	Ok = 200,
	Accepted = 202,
	NoContent = 204,
	RefreshContent = 205,
}

export enum VideoSourceType {
	None = -1,
	StaffScreen = 0,
	CustomerScreen = 1,
	StaffCamera = 2,
	CustomerCamera = 3,
	CocustomerScreen = 4,
	CocustomerCamera = 5,
}

export enum ExceptionType {
	Unknown = 0,
	Fraud = 10,
}

export enum FraudRiskLevel {
	Unknown = 0,
	NoRisk = 10,
	LowRisk = 20,
	HighRisk = 30,
}

export enum ComponentApi {
	Options = 0,
	Composition = 1,
}

export enum TradeInType {
	/**The car they are trading in was a finance or cash deal */
	PRIVATE_TRADE = 0,
	/** The car they are trading in was a lease*/
	LEASE_TRADE_IN = 1,
	/** They are not trading in the vehicle, and we are paying off the remaining amount*/
	LEASE_WALK_AWAY = 2,
}
export enum RouteOneAction {
	//3. Deal Data Resource
	CreateNewDealJacket = 302,
	RetrieveDealJacket = 303,
	UpdateDealJacket = 304,
	CreatePrimaryBuyer = 305,
	RetrievePrimaryBuyer = 306,
	UpdatePrimaryBuyer = 307,
	CreateCoBuyer = 308,
	RetrieveCoyBuyer = 309,
	UpdateCoBuyer = 310,
	DeleteCoBuyer = 311,
	CreateDealJacketVehicle = 312,
	RetrieveDealJacketVehicle = 313,
	UpdateDealJacketVehicle = 314,
	DeleteDealJacketVehicle = 315,
	CreateVehicleInsurance = 316,
	RetrieveVehicleInsurance = 317,
	UpdateVehicleInsurance = 318,
	DeleteVehicleInsurance = 319,
	SearchDeal = 320,
	//4. Deal Document Resource
	UploadDealDocument = 402,
	RetrieveDealDocument = 403,
	RetrieveAllDealDocuments = 404,
	DeleteDealDocument = 405,
	ApplySignatureDealDocument = 406,
	ApplyMultipleSignaturesDealDocument = 407,
	GenerateDocument = 408,
	RetrieveDealDocumentEncodedData = 409,
	//6. Credit Application Resource Version 2
	CreateCreditApplication = 603,
	AutoSubmitCreditApplication = 604,
	AddFinanceSources = 605,
	MarkContractasReadytoGenerate = 606,
	GetFinanceSourceCustomAndOptionalField = 607,
	DealRefresh = 608,
	ORSAutoSubmitCreditApplication = 609,
	GetCreditApplicationFields = 610,
	GetCreditApplicationGUIDbyConversationID = 611,
	//7. Compliance Status Resource
	GetIDVandOFACStatus = 702,
	//8. eContract Resource
	CreateEContractfromDealJacket = 802,
	UpdateEContractfromDealJacket = 803,
	ValidateExistingEContract = 804,
	GenerateEContract = 805,
	GetEContractStatus = 806,
	ReviewEContract = 807,
	DeleteEContract = 808,
	DistributeEContract = 809,
	//special HMAC testing
	HMACVerify = 1000,
}

export enum ExternalDMSSource {
	Other = 0,
	CDK = 1,
	Reynolds = 2,
}

export enum DealSource {
	Saturn = 0,
	CDK = 1,
	Reynolds = 2,
}

export type RouteOneDocumentType =
	| 'AAN'
	| 'ACCPHYDMGINSAGMT'
	| 'ADMINFEEDISC'
	| 'AFTMKTESGN'
	| 'AMTFINANCEDISC'
	| 'APPRBNDLD'
	| 'ARBITRATIONAGMT'
	| 'ASISNOWRNTY'
	| 'AUTOPAYAUTH'
	| 'BNDLDPROT'
	| 'BUYERSORDER'
	| 'CA'
	| 'CB'
	| 'CCTNC'
	| 'CERTWRNTY'
	| 'CNTRTANCLRY'
	| 'CNTRTRVW'
	| 'CNTRTSGN'
	| 'COLEASEAGMT'
	| 'COMLEASEGRNTY'
	| 'COMRETAILGRNTY'
	| 'CONSENTFORM'
	| 'CONTRACT'
	| 'CONTRACTADNDM'
	| 'CORPRESOLVECERT'
	| 'COSIGNERNOTICE'
	| 'CRDTDSBLTY'
	| 'CRDTLIFE'
	| 'CRDTRECISSIONAGMT'
	| 'CREDITREPORTAUTH'
	| 'CUSTOMERDISC'
	| 'DEALERRATEEX'
	| 'DEBTCANCELAGMT'
	| 'DELIVERYREPORT'
	| 'DENTDING'
	| 'DISCOUNITNGLIST'
	| 'DISPUTERESOLVEAGMT'
	| 'DLRASSIGNAPP'
	| 'DRIVERSLICENSE'
	| 'ECVLTD'
	| 'EMPLOYMENTPROOF'
	| 'FAX'
	| 'FIRSTPAYCOUPON'
	| 'GAP'
	| 'GAPCANCELDISC'
	| 'GMCCTNC'
	| 'GROSSCAPCOSTITM'
	| 'IDV'
	| 'IDVOFAC'
	| 'IMPLIEDWRNTYWAIVE'
	| 'INCOMEPROOF'
	| 'INCTVACK'
	| 'INSCERT'
	| 'KEYREPL'
	| 'LEASEMILEAGEDISC'
	| 'LEASEWORKSHEET'
	| 'MIRAICUSTOMERDISC'
	| 'NEGEQUITYDISC'
	| 'NEWVEHICLENVOICE'
	| 'ODOMETERDISC'
	| 'OFAC'
	| 'Other'
	| 'PAYOFFAUTH'
	| 'PERSONALREFS'
	| 'PNTFBRC'
	| 'POLUTIONCONTROL'
	| 'POWEROFATTORNEY'
	| 'PP'
	| 'PREPDMAINT'
	| 'PRISIGNERNOTICE'
	| 'RATEDETERMINATION'
	| 'RAV4ELECTDSCL'
	| 'RBP'
	| 'RDDCONSENTFORM'
	| 'REBATE'
	| 'REMOTEESIGNCONSENT'
	| 'RESIDENCEPROOF'
	| 'SPOTDELIVERYAGMT'
	| 'TAXNOTICE'
	| 'TAXREMIT'
	| 'THFTPRVETON'
	| 'THFTRECOV'
	| 'TRANSLATIONACK'
	| 'TRDGARNT'
	| 'TRWHL'
	| 'USEDVEHRPT'
	| 'USEDVHCLWARRANTY'
	| 'VERBALCOMMITACK'
	| 'VHCLSVCAGRMNT'
	| 'VHCLTTLEAPP'
	| 'WARRANTYMAINACK'
	| 'WEARTEAR'
	| 'WEOWE'
	| 'WSHLD';
